import type { Category } from './Category.ts';

export class Backup {
  categories: Category[] = [];
  //lastModified: number = Date.now(); // Timestamp hinzufügen
  deletedKeys: { [key: string]: number } = {};

  toPlain(): object {
    return {
      categories: this.categories.map((c) => ({
        id: c.id ?? '',
        name: c.name ?? '',
        icon: c.icon ?? '',
        dailyGoal: c.dailyGoal ?? 0,
        createdAt: c.createdAt ?? 0,
        lastModified: c.lastModified ?? 0,
        taskIds: c.taskIds ?? [],
        sharedTaskIds: c.sharedTaskIds ?? [],
        scores: c.scores.map((s) => ({
          id: s.id ?? '',
          task: s.task ?? '',
          value: s.value ?? 0,
          createdAt: s.createdAt ?? 0,
          lastModified: s.lastModified ?? 0,
        })),
      })),
      deletedKeys: this.deletedKeys ?? [],
    };
  }
}
